import { memo } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BzModal, BzModalHeader, BzModalBody, BzButton, BzModalFooter } from '../../../components';
import { useDispatch, useSelector } from 'react-redux';
import { handleModal, handleModalData } from '../../../redux/actions/modals';
import { SURV_MEASURE_POPUP_ACTION } from '../../../utils/global_variables';
import { setCautionaryMessageFromPopup } from '../../../redux/actions/orders';
//BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024 - Start
const SurvMeasureModal = ({ arrSurvData, setIsSurvMeasure, setArrSurvMeasureData }) => {
    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);

    const handleCautionaryMessage = (userResp) => {

        let mktId = [];
        let token = [];
        let strText = [];
        //  Azeem K :08-08-2025 :BREEZE-9398  -Cautionary Message Pop-up Alert Logs - Enhancement - Breeze  --Start
        let symbol = [];
        let buySell = [];
        //  Azeem K :08-08-2025 :BREEZE-9398  -Cautionary Message Pop-up Alert Logs - Enhancement - Breeze  --End
        for (let i = 0; i < arrSurvData?.length; i++) {
            mktId?.push(arrSurvData[i]?.marketSegmentId);
            token?.push(arrSurvData[i]?.token);
            strText?.push(arrSurvData[i]?.cautionaryText);
            //  Azeem K :08-08-2025 :BREEZE-9398  -Cautionary Message Pop-up Alert Logs - Enhancement - Breeze  --Start
            symbol?.push(arrSurvData[i]?.symbol);
            buySell?.push(arrSurvData[i]?.buySell);
            //  Azeem K :08-08-2025 :BREEZE-9398  -Cautionary Message Pop-up Alert Logs - Enhancement - Breeze  --End
        }
        mktId = mktId?.join('$');
        token = token?.join('$');
        strText = strText?.join('$');
        //  Azeem K :08-08-2025 :BREEZE-9398  -Cautionary Message Pop-up Alert Logs - Enhancement - Breeze  --Start
        symbol = symbol?.join('$');
        buySell = buySell?.join('$');
        //  Azeem K :08-08-2025 :BREEZE-9398  -Cautionary Message Pop-up Alert Logs - Enhancement - Breeze  --End

        dispatch(setCautionaryMessageFromPopup(userResp, strText, mktId, token, symbol, buySell));//  Azeem K :05-08-2025 :BREEZE-9398  -Cautionary Message Pop-up Alert Logs - Enhancement - Breeze : LLD Comment: will pass two more argument in setCautionaryMessageFromPopup function (buysell & symbol)

    };

    const handleYesClick = () => {
        handleCautionaryMessage(SURV_MEASURE_POPUP_ACTION.YES);
        setIsSurvMeasure(false);
        setArrSurvMeasureData([]);
        dispatch(handleModal([{ 'SURV_MEASURE': false }]), true);
        dispatch(handleModalData({ data: { isSurvMeasureAccepted: true } }));
    };
    const handleNoClick = () => {
        handleCautionaryMessage(SURV_MEASURE_POPUP_ACTION.NO);
        setIsSurvMeasure(false);
        setArrSurvMeasureData([]);
        dispatch(handleModal([{ 'SURV_MEASURE': false }]), true);
        dispatch(handleModalData({ data: { isSurvMeasureRejected: true } }));
    };

    return (
        <>
            <BzModal data-testid="ordercart-survmeasure-modal" size='sm' show={modals['SURV_MEASURE']} className='modal-breeze'>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col className='d-flex justify-content-start align-items-center'>
                                <div  data-testid="ordercart-survmeasure-modal-title" className='font-medium font-size4 color-text'>Security Measure Category</div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        {arrSurvData?.map(eachData => {
                            return <>
                                <Row className='g-0 mb-2'>
                                    <Col className='d-flex justify-content-start'>
                                        <div className='font-regular font-size4 color-text' dangerouslySetInnerHTML={{ __html: eachData?.textString }}></div>
                                    </Col>
                                </Row>
                            </>;
                        })}
                        <Row className='g-0'>
                            <Col className='d-flex justify-content-start'>
                                <div className='font-regular font-size4 color-text'>Do you wish to continue?</div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalBody>
                <BzModalFooter>
                    <Container fluid className='p-0 m-0'>
                        <Row className='g-0 justify-content-end'>
                            <Col md={10} className='d-flex align-items-center'>
                                <BzButton data-testid="ordercart-survmeasure-modal-no-button" className='btn btn-md btn-block btn-outline me-3' onClick={handleNoClick}>No</BzButton>
                                <BzButton data-testid="ordercart-survmeasure-modal-yes-button" className='btn btn-md btn-block btn-primary' onClick={handleYesClick}>Yes</BzButton>
                            </Col>
                        </Row>
                    </Container>
                </BzModalFooter>
            </BzModal>
        </>
    );
};

export default memo(SurvMeasureModal);
//BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024 - End
